import React from 'react';

import { Modal, ResponsiveWidth } from '../../../common';
import { Stepper } from '../../../common/stepper';
import { AppointmentRegistrationModalProps } from './appointment-registration-modal.models';
import { appointmentRegistrationSteps } from './appointment-registration-modal.steps';

export const AppointmentRegistrationModal = ({
  updateAppointments, onDone, goNextButtonTestId, goNextButtonTestIdsByStep, ...props
}: AppointmentRegistrationModalProps): JSX.Element => (
  <Modal
    {...props}
    responsiveWidth={ResponsiveWidth.mdFixed}
    content={(
      <Stepper
        disableStepIndicators
        steps={appointmentRegistrationSteps}
        externalState={{ updateAppointments }}
        onDone={onDone}
        hideBackOnFirstStep
        isModalBackButton
        goNextButtonTestId={goNextButtonTestId}
        goNextButtonTestIdsByStep={goNextButtonTestIdsByStep}
      />
    )}
  />
);
